import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { EStageId } from '../../utils/journeysUtils';

// GraphQL mutation
const CREATE_JOURNEY_MUTATION = gql`
  mutation createJourney($data: JourneyInput!) {
    createJourney(data: $data) {
      _id
      userId
      gameType
      currentStage
      completedAt
      history {
        stageId
        type
        completedAt
        details
      }
    }
  }
`;

// Input types for TypeScript
export interface CreateJourneyInputType {
  currentStage: EStageId;
  userId: string;
  gameType: string; // GraphQL GameType enum, but typed as string client-side
}

export interface CreateJourneyMutationType {
  createJourney: {
    _id: string;
    userId: string;
    gameType: string;
    currentStage: EStageId;
    completedAt?: string;
    history: {
      stageId: EStageId;
      type: string;
      completedAt: string;
      details?: string;
    }[];
  };
}

export interface CreateJourneyMutationVariables {
  data: CreateJourneyInputType;
}

// Custom hook
export function useCreateJourneyMutation(
  options?: MutationHookOptions<CreateJourneyMutationType, CreateJourneyMutationVariables>,
) {
  return useMutation<CreateJourneyMutationType, CreateJourneyMutationVariables>(
    CREATE_JOURNEY_MUTATION,
    options,
  );
}
